<i18n>
{
	"no":{
		"outbound": "Utgående EDI",
		"inbound": "Inngående EDI"
	},
	"en":{
		"outbound": "Outbound EDI",
		"inbound": "Inbound EDI"
	}
}
</i18n>
<template>
	<div class="edi-direction">
		<div v-if="ediLogRecord.type === 'outbound'">
			<t-timpex-icon
				v-if="ediLogRecord.error"
				icon="order-warning"
				color="red"
			/>
			<t-timpex-icon
				v-else-if="!ediLogRecord.sent"
				icon="time"
				type="bp"
				color="orange"
			/>
			<t-timpex-icon
				v-else
				icon="tick"
				type="bp"
				color="green"
				style="padding-left: 3px;"
			/>
		</div>
		<div v-else>
			<t-timpex-icon
				icon="tick"
				type="bp"
				color="green"
				style="padding-left: 3px;"
			/>
		</div>
	</div>

</template>

<script>
export default {
	props:{
		ediLogRecord: Object
	},
};
</script>

<style lang="scss" scoped>
.edi-direction{
	display: grid;
	width:100%;
	grid-template-columns: 50px 200px;
}
</style>